import * as chat from '../../service/aimsChat';
const initialState = {recommendation:{
            ultimateTestDriveDaysLeft: "22",
            ultimateTestDriveStartDay: "05/01/2020",
            ultimateRecommendationDay: "05/30/2020",
            ultimateRecommendationCustomerChoiceByDay: "06/19/2020",
            ultimateRecommendationAutoEnrolledDay: "06/30/2020",
            trialPeriodOver: false   
         
},
sspusageinfo:{},
bannertitle: 'The best plan for you',
atomRecommendTv: '',
selectedFiosFiveChannels: [],
testdriverecomm: '',
selectedRecommPlan: null 
}

function tvRecommender(state = initialState, action) {
    switch (action.type) {
        case 'UTD_RECOMMENDATION_INFO':
            let recommendation = Object.assign({}, state.recommendation, {
                ultimateTestDriveDaysLeft: action.value.ultimateTestDriveDaysLeft,
                ultimateTestDriveStartDay: action.value.ultimateTestDriveStartDay,
                ultimateRecommendationDay: action.value.ultimateRecommendationDay,
                ultimateRecommendationCustomerChoiceByDay: action.value.ultimateRecommendationCustomerChoiceByDay,
                ultimateRecommendationAutoEnrolledDay: action.value.ultimateRecommendationAutoEnrolledDay,
                trialPeriodOver: action.value.trialPeriodOver
            })
            return Object.assign({}, state, {
                recommendation: recommendation
            })
            // return Object.assign({}, state.recommendation, {
            //     ultimateTestDriveDaysLeft: action.value.ultimateTestDriveDaysLeft,
            //     ultimateTestDriveStartDay: action.value.ultimateTestDriveStartDay,
            //     ultimateRecommendationDay: action.value.ultimateRecommendationDay,
            //     ultimateRecommendationCustomerChoiceByDay: action.value.ultimateRecommendationCustomerChoiceByDay,
            //     ultimateRecommendationAutoEnrolledDay: action.value.ultimateRecommendationAutoEnrolledDay,
            //     trialPeriodOver: action.value.trialPeriodOver
            // })
            case "SSP_USEAGE_INFO":
                // let sspusageinfo = Object.assign({}, state.sspusageinfo, {
                //     ultimateTestDriveDaysLeft: action.value.ultimateTestDriveDaysLeft,
                //     ultimateTestDriveStartDay: action.value.ultimateTestDriveStartDay,
                //     ultimateRecommendationDay: action.value.ultimateRecommendationDay,
                //     ultimateRecommendationCustomerChoiceByDay: action.value.ultimateRecommendationCustomerChoiceByDay,
                //     ultimateRecommendationAutoEnrolledDay: action.value.ultimateRecommendationAutoEnrolledDay,
                //     trialPeriodOver: action.value.trialPeriodOver
                // })
                return Object.assign({}, state, {
                    sspusageinfo: action.value
                })

        
            case "TEST_DRIVE_RECOMM":
                return Object.assign({}, state, {
                    testdriverecomm: action.value
                })

            case "SELECTED_RECOMM_PLAN":
                return Object.assign({}, state, {
                    selectedRecommPlan: action.value
                })

            case "ATOM_RECOMMENDED_TV":
                return Object.assign({}, state, {
                    atomRecommendTv: action.value
                })

            case "BANNER_TITLE":
                return Object.assign({}, state, {
                    bannertitle: action.value
                })
            case "SELECTED_FIOSFIVE_CHANNELS":
                return Object.assign({}, state, {
                    selectedFiosFiveChannels: action.value
                })

        default:
            return state
    }
}


export default tvRecommender
